import type { GroupedReward } from './rewards.schema';
import { z } from 'zod';
import { ENDPOINTS } from '@/queries/endpoints';
import { httpClient } from '@/queries/httpClient';
import { validateWithZod } from '@/utils/zod.utils';
import { GroupedRewardSchema } from './rewards.schema';

export const rewardsApi = {
  async claimDailyReward(bonusRuleId: string) {
    const response = await httpClient.post(ENDPOINTS.rewards.claimDailyReward, { bonusRuleId });

    return response;
  },
  async getGrouped() {
    const response = await httpClient.get<GroupedReward[]>(ENDPOINTS.rewards.grouped);

    return validateWithZod(z.array(GroupedRewardSchema), response, 'backend');
  },
};
